import { useEffect, useState } from "react";

export default function RightDocSidebar({ groups }) {
    const [activeId, setActiveId] = useState(null);
    const [openGroup, setOpenGroup] = useState(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setActiveId(entry.target.id);
                    }
                });
            },
            {
                rootMargin: "-40% 0px -55% 0px",
                threshold: 0,
            }
        );

        groups.forEach((group) => {
            group.items.forEach((item) => {
                const el = document.getElementById(item.id);
                if (el) observer.observe(el);
            });
        });

        return () => observer.disconnect();
    }, [groups]);

    return (
        <aside className="hidden xl:block top-0 sticky self-start w-64">
            <div className="border-l pl-4 space-y-4 text-sm">

                <p className="text-md font-bold text-slate-400 uppercase">
                    On this page
                </p>

                {groups.map((group, gi) => {
                    const isExpandable = group.expandable;
                    const isOpen = openGroup === gi;

                    return (
                        <div key={gi} className="space-y-1">

                            {/* GROUP TITLE */}
                            <button
                                onClick={() => {
                                    if (isExpandable) {
                                        setOpenGroup(isOpen ? null : gi);
                                    } else {
                                        document
                                            .getElementById(group.items[0].id)
                                            ?.scrollIntoView({ behavior: "smooth" });
                                    }
                                }}
                                className={`flex items-center justify-between w-full text-left font-medium transition
                  ${activeId === group.items[0].id
                                        ? "text-[#C9A24E]"
                                        : "text-slate-700 hover:text-[#C9A24E]"
                                    }`}
                            >
                                {group.title}

                                {isExpandable && (
                                    <i
                                        className={`fa-solid ${isOpen ? "fa-chevron-up" : "fa-chevron-down"
                                            } text-xs`}
                                    />
                                )}
                            </button>

                            {/* SUB ITEMS */}
                            {isExpandable && isOpen && (
                                <div className="pl-3 space-y-1">
                                    {group.items.map((item) => (
                                        <button
                                            key={item.id}
                                            onClick={() =>
                                                document
                                                    .getElementById(item.id)
                                                    ?.scrollIntoView({ behavior: "smooth" })
                                            }
                                            className={`block text-left transition pt-2 ${activeId === item.id
                                                    ? "text-[#C9A24E] font-medium"
                                                    : "text-slate-500 hover:text-slate-800"
                                                }`}
                                        >
                                            {item.label}
                                        </button>
                                    ))}
                                </div>
                            )}

                        </div>
                    );
                })}
            </div>
        </aside>
    );
}
